import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import {DashboardSectionOptions} from '../../dashboard/dashboard-section/dashboard-section-options';
import {TransportInterventionsStatus} from 'shared';
import {DashboardService} from '../../services/dashboard.service';
import {WebsocketService} from '../../services/websocket/websocket.service';
import {Subscription} from 'rxjs';
import {TransportInterventionsRealtimeReportComponent} from '../transport-interventions-realtime-report/transport-interventions-realtime-report.component';

@Component({
  selector: 'app-transport-interventions-realtime-list',
  templateUrl: './transport-interventions-realtime-list.component.html',
  styleUrls: ['./transport-interventions-realtime-list.component.scss']
})
export class TransportInterventionsRealtimeListComponent implements OnInit, OnDestroy {
  ds: DataSource;
  store: ArrayStore;
  listGrouped: boolean;
  private sub: Subscription;
  private markedForDeletion: Map<number, TransportInterventionsStatus> = new Map();
  private deletionInterval: number;

  @ViewChild(TransportInterventionsRealtimeReportComponent)
  realtimeReport: TransportInterventionsRealtimeReportComponent;

  constructor(public options: DashboardSectionOptions, private ws: WebsocketService) {
  }

  ngOnInit(): void {

    // Array Store
    this.store = new ArrayStore({
      key: 'id',
      data: [],
    });

    // Data source
    this.ds = new DataSource({
      paginate: false,
      reshapeOnPush: true,
      pushAggregationTimeout: 500,
      sort: [{selector: 'start_time', desc: true}],
      store: this.store,
    });

    // Interventions status
    this.sub = this.ws.topicObserver('TransportInterventionsStatus', TransportInterventionsStatus)
      .subscribe((t: TransportInterventionsStatus) => {
        this.realtime(t);
      });

    // Deletion Schedule
    this.deletionSchedule();
  }

  itemClick(e: any) {
  }

  private deletionSchedule() {
    this.deletionInterval = window.setInterval(() => {
      this.markedForDeletion.forEach((t) => {
        if (t.stop_time === null) {
          return;
        }
        const now = new Date();
        const elapsed = (now.getTime() - t.stop_time.getTime()) / 1000;
        if (elapsed > 30) {
          this.store.push([{type: 'remove', key: t.id}]);
          this.markedForDeletion.delete(t.id);
        }
      });
    }, 2000);
  }

  private realtime(t: TransportInterventionsStatus) {

    if (t.finished()) {
      this.markedForDeletion.set(t.id, t);
    }

    this.store.byKey(t.id).then(() => {
      this.store.push([{type: 'update', key: t.id, data: t}]);
    }, () => {
      this.store.push([{type: 'insert', data: t}]);
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    clearInterval(this.deletionInterval);
  }

  menuClick(action: string, status: TransportInterventionsStatus) {
    switch (action) {
      case 'follow':
        this.realtimeReport.startFollow(status);
        break;
    }
  }
}
